import { useTranslation } from '../i18n';
import "./LanguageTransition.css";

function WeAreSayingYes() {
  const { t, isTransitioning } = useTranslation();
  const screenWidth = window.innerWidth;
  const isTablet = screenWidth <= 440;
  
  const containerStyle = {
    textAlign: 'left',
    marginLeft: '1rem',
  };

  const wirSagenStyle = {
    fontFamily: 'var(--font-serif)',
    fontWeight: '300',
    fontSize: isTablet ? '5rem' : '6rem',
    color: 'var(--text-dark)',
    margin: 0,
    lineHeight: '1.2',
  };

  const jaStyle = {
    fontFamily: 'var(--font-monsieur)',
    fontWeight: '400',
    fontSize: isTablet ? '6.67rem' : '8rem',
    color: 'var(--text-dark)',
    margin: '0 0 0 5rem',
    lineHeight: '1.2',
  };

  return (
    <div className={`language-transition ${isTransitioning ? 'fade-out' : 'fade-in'}`} style={containerStyle}>
      <div style={wirSagenStyle}>{t('weAreSayingYes.weAreSaying')}</div>
      <div style={jaStyle}>{t('weAreSayingYes.yes')}</div>
    </div>
  );
}

export default WeAreSayingYes;